export default "__VITE_ASSET__CDxKoVMr__"